

<template>
    <div>
        <!-- <h2>form5</h2> -->
        <a-form-model ref="ruleForm" :model="form" :label-col="labelCol"  :rules="rules">
            <a-row class="flex-row">
                <a-col :span="12">
                    <a-form-model-item label="所属品系" prop="strainsNameList" :label-col="{span:4, style: { width: '100px' }}">
                      <div style="display: flex; flex-direction: column; gap: 4px;width: 100%">
                        <a-select v-model="form.strainsNameList" mode="multiple" placeholder="请选择品系" :collapse-tags="true" @change="onStrainsChange" :disabled="isDisabled()" >
                          <!-- <a-select-option  value="0" >全部</a-select-option> -->
                          <a-select-option v-for="item in carStrainsDS" :key="item.strainsCode"  :value="item.strains" >{{item.strains}}</a-select-option>
                        </a-select>
                        <div style="color: #999; font-size: 12px; line-height: 1.4;">
                          注意：公路用车与工程用车不可同时选择
                        </div>
                      </div>
                    </a-form-model-item>
                </a-col>
                <!-- <a-col :span="12">
                    <a-form-model-item label="计划时间" prop="planTime">
                        <a-date-picker valueFormat="YYYY-MM-DD" v-model="form.planTime" class="date-picker"/>
                    </a-form-model-item>
                </a-col> -->
                <a-col :span="12">
                    <a-form-model-item label="地点" prop="activityPlace" :label-col="{span:4, style: { width: '100px' }}">
                        <a-cascader
                            v-model="form.activityPlace"
                            :options="regionOptions"
                            :fieldNames="{ label: 'areaName', value: 'areaName', children: 'children' }"
                            placeholder="请选择区域"
                            allowClear
                            :disabled="isDisabled()"
                        />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="详细地址" :label-col="{span:4, style: { width: '100px' }}">
                        <a-input v-model="form.addressInfo" :disabled="isDisabled()" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="关怀人数" prop="careNum" :label-col="{span:4, style: { width: '100px' }}">
                        <a-input-number :min="0" :max="50" v-model="form.careNum" @change="onCareNumChange" :disabled="isDisabled()"/>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <div v-if="customerList.length">
                <div class="item-line">客户信息</div>
                <!-- <a-row v-for="(item, index) in customerList" :key="index">
                    <a-col :span="8">
                        <a-form-model-item label="姓名" prop="name" :label-col="{span:6}">
                            <a-input v-model="item.name"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-model-item label="底盘号" prop="chassisNum" :label-col="{span:6}">
                            <a-input v-model="item.chassisNum" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-model-item label="手机号" prop="phoneNum" :label-col="{span:6}">
                            <a-input v-model="item.phoneNum" />
                        </a-form-model-item>
                    </a-col>
                </a-row> -->
                <div class="filter-container" style="padding: 0px 1%">
                    
                    <el-form ref="formBan" :model="modelVal" label-width="14px">
                        <vxe-table
                            ref="xTable"
                            border
                            show-header-overflow
                            show-overflow
                            class="mytable-scrollbar"
                            :column-config="{ resizable: true }"
                            stripe
                            round
                            style="margin-top: 10px"
                            :max-height="$store.state.app.height - 300 > 200 ? $store.state.app.height - 200 : 200"
                            :scroll-y="{ enabled: false }"
                            :row-config="{ isHover: true }"
                            :data="customerList"
                        >
                        <!-- <vxe-column type="checkbox" width="60" align="center" /> -->
                        <vxe-column type="seq" title="序号" width="60" align="center" />
                        <!-- <vxe-column title="车型名称" field="vehicleModel" align="center" />
                        <vxe-column title="数量" field="quantity" align="center" /> -->
                        <vxe-column title="姓名">
                            <template #default="scope">
                            <el-form-item label=" ">
                                <a-input v-model="scope.row.name" :disabled="isDisabled()"/>
                            </el-form-item>
                            </template>
                        </vxe-column>
                        <vxe-column title="底盘号">
                            <template #default="scope">
                            <el-form-item label=" ">
                                <a-input v-model="scope.row.chassisNum" :disabled="isDisabled()"/>
                            </el-form-item>
                            </template>
                        </vxe-column>
                        <vxe-column title="手机号">
                            <template #default="scope">
                            <el-form-item label=" ">
                                <a-input v-model="scope.row.phone" :disabled="isDisabled()"/>
                            </el-form-item>
                            </template>
                        </vxe-column>
                    </vxe-table>
                </el-form>
            </div>
            </div>
            <!-- <div class="item-line">负责人信息</div> -->
            <a-row>
                <a-col :span="12">
                    <a-form-model-item label="负责人姓名" prop="headName" :label-col="{span:4, style: { width: '100px' }}">
                        <a-input v-model="form.headName" :disabled="isDisabled()" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="负责人电话" prop="headName" :label-col="{span:4, style: { width: '100px' }}">
                        <a-input v-model="form.headPhone" :disabled="isDisabled()" />
                    </a-form-model-item>
                </a-col>
                
            </a-row>   
            <a-row>
              <a-col :span="24">
                  <a-form-model-item label="备注" :label-col="{span:3, style: { width: '100px' }}" class="sign-tiem widthHuo">
                      <a-textarea :auto-size="{ minRows: 2, maxRows: 6 }" v-model="form.remark" :disabled="isDisabled()" />
                  </a-form-model-item>
              </a-col>
          </a-row>
            <!-- <div class="item-line">费用预算</div> --> 
             <!-- lr0043 -->
            <div class="item-line">费用信息</div>
            <a-row class="flex-row">
                <a-col :span="6">
                    <a-form-model-item label="礼品费" :label-col="{span:4, style: { width: '100px' }}">
                        <a-input-number :min="0" @change="gettotalCost" v-model="form.giftFee" :disabled="isDisabled()" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="其他" :label-col="{span:4, style: { width: '100px' }}">
                        <a-input-number :min="0" @change="gettotalCost" v-model="form.otherFee" :disabled="isDisabled()" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="合计" :label-col="{span:4, style: { width: '100px' }}">
                        <!-- <a-input-number :min="0" v-model="form.totalCost" /> -->
                        <a-input-number :min="0" v-model="form.totalCost" disabled/>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <!-- <div class="item-line">上传附件</div> -->
          
            <a-row v-if="approveBtnDisplay === true">
            <!-- <a-row> -->
                <a-col :span="6">
                    <a-form-model-item :label-col="{span:4, style: { width: '100px' }}" label="经销商已补差">
                        <a-input v-model="form.dealerDiff" disabled />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item :label-col="{span:4, style: { width: '100px' }}" label="区域已补差">
                        <a-input v-model="form.areaDiff" disabled />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item :label-col="{span:4, style: { width: '100px' }}" label="最高支持费用">
                        <a-input v-model="form.maxSupportFee" :disabled="isDisabled()" />
                    </a-form-model-item>
                </a-col>
                <!-- <a-col :span="18">
                    <a-form-model-item label="申请表扫描件" v-if="(typeof (this.form.planApplyCode) !== 'undefined')" :label-col="{span:3, style: { width: '100px' }}" class="act-item widthHuo">
                        <el-upload
                            
                            ref="uploadFile"
                            class="upload-demo"
                            action=""
                            :before-upload="beforeUpload"
                            :on-preview="onPreviewFun"
                            :on-change="handleChange"
                            :on-remove="handleRemove"
                            :http-request="uploadHttpRequest"
                            :before-remove="beforeRemove"
                            :auto-upload="false"
                            :file-list="fileList"
                        >
                            <el-button slot="trigger" icon="el-icon-top" size="small">点击上传</el-button>
                        </el-upload>
                        
                    </a-form-model-item>
                    <a-form-model-item label="申请表扫描件" v-if="(typeof (form.planApplyCode) === 'undefined')" :label-col="{span:3, style: { width: '100px' }}" class="act-item widthHuo">
                      <el-button @click="uploadClick" icon="el-icon-top" size="small">点击上传</el-button>
                    </a-form-model-item>
                </a-col> -->
            </a-row>
           
        </a-form-model>
    </div>
</template>

<script>
import { loadAreaTreeCasData } from '@/services/baseCodeSource';
import { queryCarStrainsInfo, getApproveWriteOffCost } from '@/api/activity.js'
import { deleteFile, uploadPlanFiles, findFileInfo } from '@/api/actPlan'
const activityFormMap = {
        // "form1": ["直播（短视频）", "网红传播", "试驾推介会", "婚车", "赞助", "交车仪式", "客户联谊", "意向合作伙伴来柳", "意向网络座谈", "渠道培训"],
        // "form2": ["产品展示"],
        // "form3": ["客户拜访（座谈）", "双节拜访", "客户来柳参观", "行业客户专项拜访"],
        // "form4": ["平台运营"],
        // "form5": ["事件慰问", "望子乘龙", "乘龙助学", "卡友体检", "公益项目"],
        // "form7": ["广告", "发布品鉴会（答谢会）"]

        "form1": ["直播（短视频）", "网红传播", "试驾推介会", "婚车服务", "生态赞助", "交车仪式", "客户联谊", "意向合作伙伴来柳", "意向网络座谈", "渠道培训", "集中交车"],
        "form2": ["产品展示","区域车展"],
        "form3": ["客户拜访（座谈）", "双节拜访", "客户来柳参观", "行业客户专项拜访","协会入会",],
        "form4": ["平台运营"],
        "form5": ["事件慰问", "望子乘龙", "乘龙助学", "卡友体检", "公益项目"],
        "form7": ["广告投放", "品鉴会/答谢会"]
    }
export default {
    props:['formData', 'activity', 'formType', 'approveBtnType', 'priceDiff'],
    data() {
    return {
      labelCol: { span: 8, style: { width: '100px' } },
      wrapperCol: { span: 14 },
      form: {
        address: [], // 区域
        dealerName: '', // 经销商
        threeLevelName: '', // 活动类型
        strainsNameList: [],
        strainsCodeNameMap: {}, // 主推品系编码及对应名称
        // planTime: '',
        activityPlace: '',
        addressInfo:'',
        careNum: '', // 关怀人数
        isSecondaryNetwork: 1,
        headName: '',
        headPhone: '',
        conferenceFee: '', //会务费
        fuelCost: '', // 油费
        toll: '', // 过路费
        giftFee: '', // 礼品费
        moveInFee: '', // 布展费
        otherFee: '',
        totalCost: 0, //总计
        applicationForm: '', // 申请表
        dealerDiff: '',
        areaDiff: '',
        maxSupportFee: '',
        remark: ''
        // annualFee: 0, //年费
        // trainingFee: 0, //培训费
        // siteRent: 0, //场地租金
        // makeCosts: 0, //制作费用
        // otherSiteExpenses: 0, //其他场地费用
      },
      regionOptions:[],
      showCarSeries: false,
      defaultSelecteRows: [], // 默认选中行
      checkedCars: [], //已选车型
      customerList:[],
      carStrainsDS: [],
      modelVal: [],
      fileInfoList: [],
      rules: {
        mbrAreaList: [
          { required: true, message: '请选择区域', trigger: 'change' },
        ],
        dealerName: [
          { required: true, message: '请输入经销商名称', trigger: 'blur' },
        ],
        activityType: [
          { required: true, message: '请选择活动类型', trigger: 'change' },
        ],
        strainsNameList: [
          { required: true, message: '请选择所属品系', trigger: 'change' },
        ],
        strainsCarName: [
          { required: true, message: '请选择主推车型及数量', trigger: 'change' },
        ],
        planTime: [
          { required: true, message: '请选择计划时间', trigger: 'change' },
        ],
        activityPlace: [
          { required: true, message: '请输入地点', trigger: 'blur' },
        ],
        isSecondaryNetwork: [
          { required: true, message: '', trigger: 'change' },
        ],
        careNum: [
          { required: true, message: '请输入关怀人数', trigger: 'blur' },
        ],
        headName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        headPhone: [
          { required: true, message: '请输入电话', trigger: 'blur' },
          { pattern: /^[1][3-9][0-9]{9}$/, message: '请输入有效的手机号码', trigger: 'blur' },
        ],
        applicationForm: [
          { required: true, message: '', trigger: 'change' },
        ],
      },
      fileList: [],
      vehicleModelAndQuantity: [], //已选车型
      vehicleModelCheck: 0, // 0不检验 1校验 车型代码必选
      approveBtnDisplay: false

    };
  },
  created() {
    this.getArea()
    this.SelectListsFun()
    this.getCarStrains()
  },
  mounted() {
    if (this.formData && this.formData.id) {
        console.log(this.formData,'0000000');
        this.getFileInfo(this.formData.planApplyCode)
        
        setTimeout(() => {
          this.getApproveWriteOffCost()
          this.form  = Object.assign(this.form, {
              ...this.formData,
              activityPlace: this.formData.activityPlace.split(',')

          })
          this.customerList = this.formData.customerList
          if(this.carStrainsDS != null) {
            this.form.strainsCodeNameMap = this.carStrainsDS
                .filter(item => this.formData.strainsCodeList.includes(item.strainsCode))
                .reduce((obj, item) => {
                  obj[item.strainsCode] = item.strains;
                  return obj;
                }, {});
          }
          // this.form.dealerDiff = this.priceDiff.dealerDiff
          // this.form.areaDiff = this.priceDiff.areaDiff
        }, 3000)
    }
  },
  methods: {
    SelectListsFun() {
      this.$store.dispatch('SelectData/QuerySelect', ['subSeries']).then(v => {
        this.SelectLists = v
      })
    },
    async getArea() {
      this.regionOptions = await loadAreaTreeCasData();
    },
    // 使用这个映射来通过活动类型获取使用的表单
    getFormByActivity(activityType) {
    // 遍历映射对象
    for (const form in activityFormMap) {
        // 检查活动类型是否在当前表单类型的数组中
        if (activityFormMap[form].includes(activityType)) {
        return form;
        }
    }
    // 如果没有找到对应的表单，返回"未知表单"
    return "form1";
    },
    onShowCarSeries() {
        console.log("🚀 ~ onShowCarSeries ~ !this.form.strainType:", !this.form.strainType)
        if (!this.form.strainType) {
            this.$message.error('请先选择主推品系')
            return
        }
      this.$refs.selectCarSeriesPopup.blur()
      this.showCarSeries = true
      this.$nextTick(() => {
        if (!this.form.strainsCarName) {
            this.$refs.xTable.clearCheckboxRow()
        }
        // this.$refs.xTable.clearCheckboxRow()
        // const stringArray = this.activity.strainsCarCode.split(',')
        // const result = this.SelectLists.subSeries.filter(item => stringArray.some(value => item.code === value))
        // this.$refs.xTable.setCheckboxRow(result, true)
      })
    },
    gettotalCost() {
        this.form.totalCost = Number(this.form.giftFee) + Number(this.form.otherFee)
    },
    
    // 获取品系
    getCarStrains() {
      queryCarStrainsInfo().then(res => {
        if (res.code === 1) {
          this.carStrainsDS = res.data.list
          this.filteredStrains()
        }
      })
    },
    getApproveWriteOffCost() {
        getApproveWriteOffCost(this.formData.id).then(res => {
            if (res.code === 1) {
                this.form.dealerDiff = res.data.dealerApproveWriteOffCost
                this.form.areaDiff = res.data.regionApproveWriteOffCost
                this.approveBtnDisplay = res.data.display
            }
        })
    },
    // 过滤品系
    filteredStrains() {
      if (this.activity.strainsCarCode) {
        const stringArray = this.activity.strainsCarCode.split(',')
        const arr = []
        stringArray.forEach(item => {
          const itemArr = item.split('-')
          arr.push(itemArr[0])
        })
        this.carStrainsDS = this.carStrainsDS.filter(value => arr.includes(value.strainsCode))
      }
    },
    onSeriesConfirm() {
        this.checkedCars = this.$refs.xTable.getCheckboxRecords();
        if (!this.checkedCars.length) {
           return  this.$message.error('请选择车型')
        }
        if (this.checkedCars.some(item => item.count === '')) {
            return  this.$message.error('请输入已选车型的数量')
        }
        this.showCarSeries = false
        const list = this.checkedCars.map(item => `车型名称：${item.carName} - 数量：${item.count}`)
        this.form.strainsCarName = list.join('; ')
    },
    onCareNumChange() {
        let val = Number(this.form.careNum) || 0
        if (val > 50) {
            this.$message.warning('关怀人数最多50人')
            val = 50
            this.form.careNum = 50
        }
        if (val < 0) {
            val = 0
            this.form.careNum = 0
        }
        this.customerList = []
        for (let i = 0; i < val; i++) {
            this.customerList.push({
                name: '',
                chassisNum: '',
                phone: ''
            })
        }
    },
    getActivityForm() {
      const processedForm = {
        ...this.form,
        giftFee: this.form.giftFee ?? 0,
        otherFee: this.form.otherFee ?? 0,
        totalCost: this.form.totalCost ?? 0
      };

      const obj = Object.assign(processedForm, {
            address: this.activity.address,
            dealerName: this.activity.dealerName,
            threeLevelName: this.activity.threeLevelName,
            customerList: this.customerList,
            activityPlace: this.form.activityPlace.join(',')
            // activityPlace: this.formData.activityPlace.split(',')

        })
        return obj
    },
    beforeUpload(file) {
      // 文件大小限制为20M
      const fileLimit = file.size / 1024 / 1024 < 20
      if (!fileLimit) {
        this.$message.warning('上传文件大小不超过40M！')
      }
      // 返回判断条件,false停止上传
      return fileLimit
    },
    // 点击文件
    async onPreviewFun(e) {
      let pathUrl = process.env.VUE_APP_API_BASE_URL + '/'
      console.log(pathUrl + e.url,e,'---e-----');
      if (e.url) {
        // 已上传文件
        // const fileName = e.name
        // const suffix = fileName.substring(fileName.lastIndexOf('.') + 1)

        // if (this.officeTypeList.includes(suffix)) {
        //   // office打开新窗口
        //   const routeData = this.$router.resolve({
        //     query: { name: e.name, url: e.url },
        //     path: '/previewFile'
        //   })
        //   window.open(routeData.href, '_blank')
        // } else {
          // 其它类型直接打开
          window.open(pathUrl + e.url, '_blank')
        // }
      } else {
        // 未上传文件
        this.exportExcelData(e.raw, e.name)
      }
    },
    //  判断 有没有   this.form.planApplyCode
    uploadClick() {
      if (typeof (this.form.planApplyCode) === 'undefined') {
        this.$message.warning('请保存提报信息生成提报编码后再申请表扫描件')
        this.fileList = []
        return
      }
    },
    // 上传计划方案
    handleChange(file, fileList) {
      if (file.raw.size > 1024 * 1024 * 20) {
        this.$message.error('文件大小限制20M!')
        fileList.pop()
        return
      }
      const flag = this.fileList.find(item => item.name === file.name)
      if (flag) {
        this.$message.error('文件名重复，请修改文件名后重新上传!')
        fileList.pop()
        return
      }

      console.log(this.form.planApplyCode,'---this.form.planApplyCode---');
      
      
      if (typeof (this.form.planApplyCode) === 'undefined') {
        this.$message.warning('请保存提报信息生成提报编码后再申请表扫描件')
        this.fileList = []
        return
      }
      this.$emit('update:fileList', fileList)
      this.$refs.uploadFile.submit()
    },
    
    uploadHttpRequest(param) {
      if (typeof (this.form.planApplyCode) === 'undefined') {
        this.$message.warning('请保存提报信息生成提报编码后再申请表扫描件')
        this.fileList = []
        return
      }
      const formData = new FormData()
      const data = {
        type: 'actPlanApply-applicationForm',
        code: this.form.planApplyCode
      }
      const params = JSON.stringify(data)
      formData.append('params', new Blob([params], { type: 'application/json' }))
      formData.append('file', param.file)
      uploadPlanFiles(formData).then(res => {
        if (res.code === 1) {
          this.$message.success('上传成功')
        }
      })
    },
    beforeRemove() {
    },
    handleRemove(file, fileList) {
        console.log(file,fileList,'00000000000');
        
    //   if (file.status === '1') {
        const params = {
          name: file.name,
          code: this.form.planApplyCode,
          module: 'actPlanApply-applicationForm'
        }
        deleteFile(params).then(res => {
          if (res.code === 1) {
            this.$message.success('删除成功')
          }
        })
    //   }
    //   this.$emit('update:fileList', fileList)
    },
    // 获取文件信息
    getFileInfo(code) {
      // planApplyCode
      findFileInfo(code).then(res => {
        if (res.code === 1 && res.data) {
          this.fileInfoList = res.data
          this.initFile()
        }
      })
    },
    initFile() {
      if (this.fileInfoList.length < 1) {
        return
      }
      this.fileInfoList.forEach(item => {
        if (item.module === 'actPlanApply-applicationForm') {
          this.fileList.push(item)
          // getFiles(item).then(res => {
          //   const file = setInitImg(res, item.name)
          //   this.fileList.push(file)
          // })
        }
      })
    },
    isDisabled() {
        console.log("🚀 ~ isDisabled ~ this.formType:", this.formType)
        return this.formType === 'detail'
    },
    onStrainsChange (e) {
      this.form.strainsCodeNameMap = this.carStrainsDS
          .filter(item => e.includes(item.strains))
          .reduce((obj, item) => {
            obj[item.strainsCode] = item.strains;
            return obj;
          }, {});
    },
  }
}
</script>

<style lang="less" scoped>
.item-line {
    padding: 0px 20px;
    width: 100%;
    margin: 0;
    background: #0a76a4;
    color: #ffffff;
    height: 30px;
    line-height: 30px;
    margin-bottom: 10px;
  }
  .flex-row {
    display: flex;
    flex-wrap: wrap;
  }
  .car-modal {
    /deep/ .ant-form {
        padding-right: 0;
      }
    /deep/ .ant-form-item-control-wrapper {
        width: 100%;
    }
  }
  .widthHuo{
    ::v-deep .ant-form-item-label{
      width:100px !important
    }
  }
  .ant-form {
    padding-right: 0px;
  }
</style>